import * as React from 'react'
import { memo } from 'react'
const SvgEmail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18.316 12"
  >
    <path
      fillRule="evenodd"
      d="M18.313 2.513A2.513 2.513 0 0 0 15.8 0H2.513A2.513 2.513 0 0 0 0 2.513v6.975A2.513 2.513 0 0 0 2.513 12h13.29a2.513 2.513 0 0 0 2.51-2.512Zm-15.679.208L8.95 8.135a.316.316 0 0 0 .411 0l6.316-5.414a.316.316 0 1 0-.411-.479l-6.11 5.237-6.11-5.237a.316.316 0 1 0-.411.479Z"
      data-name="Tracciato 3712"
    />
  </svg>
)
const Memo = memo(SvgEmail)
export default Memo
